import { render, staticRenderFns } from "./AppointmentDetails.vue?vue&type=template&id=6fd55c52&scoped=true&"
import script from "./AppointmentDetails.vue?vue&type=script&lang=js&"
export * from "./AppointmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentDetails.vue?vue&type=style&index=0&id=6fd55c52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd55c52",
  null
  
)

export default component.exports